module.exports = "<div class=\"container-fluid\" dynamicPage>\r\n    <router-outlet></router-outlet>\r\n  </div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/page/page.component.html
// module id = ./src/app/views/page/page.component.html
// module chunks = main